import { Type } from '@angular/core';
import { Route } from '@angular/router';

import { PTypes } from '@digital-platform/rs-cms/domain';

type PTypeRoute = Omit<Route, 'loadComponent'> & {
  loadComponent: () => Promise<Type<PTypes>>;
};

export const PTYPES_ROUTES: PTypeRoute[] = [
  {
    path: 'breadcrumbs',
    loadComponent: () =>
      import('./breadcrumbs-ptype/breadcrumbs-ptype.component').then(
        (c) => c.BreadcrumbsPtypeComponent
      ),
  },
  {
    path: 'ctaButton',
    loadComponent: () =>
      import('./cta-button/cta-button.component').then(
        (c) => c.CtaButtonComponent
      ),
  },
  {
    path: 'dualOverlainImage',
    loadComponent: () =>
      import('./dual-overlain-image/dual-overlain-image.component').then(
        (c) => c.DualOverlainImageComponent
      ),
  },
  {
    path: 'emailOptIn',
    loadComponent: () =>
      import('./email-opt-in/email-opt-in.component').then(
        (c) => c.EmailOptInComponent
      ),
  },
  {
    path: 'flexboxContentContainer',
    loadComponent: () =>
      import(
        './flexbox-content-container/flexbox-content-container.component'
      ).then((c) => c.FlexboxContentContainerComponent),
  },
  {
    path: 'flexboxItem',
    loadComponent: () =>
      import('./flexbox-item/flexbox-item.component').then(
        (c) => c.FlexboxItemComponent
      ),
  },
  {
    path: 'footer',
    loadComponent: () =>
      import('./footer/footer.component').then((c) => c.FooterComponent),
  },
  {
    path: 'heroCarousel',
    loadComponent: () =>
      import('./hero-carousel/hero-carousel.component').then(
        (c) => c.HeroCarouselComponent
      ),
  },
  {
    path: 'image',
    loadComponent: () =>
      import('./image/image.component').then((c) => c.ImageComponent),
  },
  {
    path: 'imageBanner',
    loadComponent: () =>
      import('./image-banner/image-banner.component').then(
        (c) => c.ImageBannerPTypeComponent
      ),
  },
  {
    path: 'inlineImage',
    loadComponent: () =>
      import('./inline-image/inline-image.component').then(
        (c) => c.InlineImageComponent
      ),
  },
  {
    path: 'layoutParagraphPage',
    loadComponent: () =>
      import('./layout-paragraph-page/layout-paragraph-page.component').then(
        (c) => c.LayoutParagraphPageComponent
      ),
  },
  {
    path: 'logoImage',
    loadComponent: () =>
      import('./logo-image/logo-image.component').then(
        (c) => c.LogoImageComponent
      ),
  },
  {
    path: 'primaryFooter',
    loadComponent: () =>
      import('./primary-footer/primary-footer.component').then(
        (c) => c.PrimaryFooterComponent
      ),
  },
  {
    path: 'primaryFooterColumn',
    loadComponent: () =>
      import('./primary-footer-column/primary-footer-column.component').then(
        (c) => c.PrimaryFooterColumnComponent
      ),
  },
  {
    path: 'primaryFooterLink',
    loadComponent: () =>
      import('./primary-footer-link/primary-footer-link.component').then(
        (c) => c.PrimaryFooterLinkComponent
      ),
  },
  {
    path: 'reusableContent',
    loadComponent: () =>
      import('./reusable-content/reusable-content.component').then(
        (c) => c.ReusableContentComponent
      ),
  },
  {
    path: 'faqItem',
    loadComponent: () =>
      import('./faq-item/faq-item.component').then((c) => c.FaqItemComponent),
  },
  {
    path: 'richText',
    loadComponent: () =>
      import('./rich-text/rich-text.component').then(
        (c) => c.RichTextComponent
      ),
  },
  {
    path: 'richTextLink',
    loadComponent: () =>
      import('./rich-text-link/rich-text-link.component').then(
        (c) => c.RichTextLinkComponent
      ),
  },
  {
    path: 'socialMediaIcons',
    loadComponent: () =>
      import('./social-media-icons/social-media-icons.component').then(
        (c) => c.SocialMediaIconsComponent
      ),
  },
  {
    path: 'subFooter',
    loadComponent: () =>
      import('./sub-footer/sub-footer.component').then(
        (c) => c.SubFooterComponent
      ),
  },
  {
    path: 'subFooterLink',
    loadComponent: () =>
      import('./sub-footer-link/sub-footer-link.component').then(
        (c) => c.SubFooterLinkComponent
      ),
  },
  {
    path: 'test',
    loadComponent: () =>
      import('./test-ptype/test-ptype.component').then(
        (c) => c.TestPTypeComponent
      ),
  },
  {
    path: 'videoModal',
    loadComponent: () =>
      import('./video-modal/video-modal.component').then(
        (c) => c.VideoModalComponent
      ),
  },
  {
    path: 'wayfinderMatrix',
    loadComponent: () =>
      import('./wayfinder/wayfinder.component').then(
        (c) => c.WayfinderComponent
      ),
  },
  {
    path: 'heroCarousel',
    loadComponent: () =>
      import('./hero-carousel/hero-carousel.component').then(
        (c) => c.HeroCarouselComponent
      ),
  },
  {
    path: 'layoutSection',
    loadComponent: () =>
      import('./layout-section/layout-section.component').then(
        (c) => c.LayoutSectionComponent
      ),
  },
  {
    path: 'accordion',
    loadComponent: () =>
      import('./accordion/accordion.component').then(
        (c) => c.AccordionComponent
      ),
  },
  {
    path: 'requestServices',
    loadComponent: () =>
      import('./request-services/request-services.component').then(
        (c) => c.RequestServicesComponent
      ),
  },
  {
    path: 'cardsCarousel',
    loadComponent: () =>
      import('./cards-carousel/cards-carousel.component').then(
        (c) => c.CardsCarouselComponent
      ),
  },
  {
    path: 'cardsCarouselCard',
    loadComponent: () =>
      import('./cards-carousel-card/cards-carousel-card.component').then(
        (c) => c.CardsCarouselCardComponent
      ),
  },
  {
    path: 'unknown',
    loadComponent: () =>
      import('./unknown-ptype/unknown-ptype.component').then(
        (c) => c.UnknownPTypeComponent
      ),
  },
];
